export default __webpack_public_path__ + "static/media/chikki.71664fec.jpg";